import { useState } from "react";
import { Form, Flex } from "antd";

import { connectCompanyAndUser } from "services";
import { useStores } from "stores";
import { useNotificationContext } from "providers";
import { CompanyEntity, NOTIFICATION_TYPE_ENUM } from "interfaces";
import { _isRequired, getAvailableUserRoles, parseErrorMessage } from "utils";
import { observer } from "mobx-react-lite";
import { CompanySelect, CustomButton, MultiplySelect } from "ui";
import { FORM_VALIDATION_DEBOUNCE } from "constants/form";

type AddCompanyProps = {
  onDataReceived?: (data: CompanyEntity) => void;
  isReport?: boolean;
};

export const AddCompanyModal = observer(({ onDataReceived, isReport }: AddCompanyProps) => {
  const { actionModals, userCard, userCompanyList } = useStores();
  const { openNotification } = useNotificationContext();

  const [loading, setLoading] = useState(false);

  const [selectedCompany, setSelectedCompany] = useState<CompanyEntity | null>(null);

  const [form] = Form.useForm();

  const closeModal = () => {
    actionModals.closeAll();
  };

  if (onDataReceived && selectedCompany) {
    onDataReceived(selectedCompany);
  }

  const onFinish = async () => {
    const values = form.getFieldsValue();

    setLoading(true);

    await connectCompanyAndUser(
      {
        id: values.id,
        userId: userCard.card.id,
      },
      values.roles
    )
      .then(() => {
        setTimeout(() => {
          userCompanyList.fetch();
          openNotification({
            message: "Компания подключена",
            type: NOTIFICATION_TYPE_ENUM.SUCCESS,
          });
        }, 1500);
        closeModal();
      })
      .catch((e) => {
        openNotification({
          description: parseErrorMessage(e),
          type: NOTIFICATION_TYPE_ENUM.ERROR,
        });
      })
      .finally(() => setLoading(false));
  };

  return (
    <Form form={form} name="addCompany" onFinish={onFinish}>
      <Flex vertical gap="small">
        <CompanySelect
          inputProps={{
            disabled: loading,
          }}
          name="id"
          onDataReceived={(data) => setSelectedCompany(data)}
        />
        {selectedCompany && !isReport && (
          <Form.Item
            name="roles"
            className="full-width"
            rules={[_isRequired("Выберите хотя бы одну роль")]}
            validateDebounce={FORM_VALIDATION_DEBOUNCE}
          >
            <MultiplySelect
              placeholder="Роли пользователя"
              disabled={loading}
              options={getAvailableUserRoles(selectedCompany.role)}
            />
          </Form.Item>
        )}
        <Form.Item>
          <Flex gap="large" className="margin-top-lg">
            {isReport ? (
              <CustomButton loading={loading} htmlType="button" onClick={closeModal}>
                Применить
              </CustomButton>
            ) : (
              <CustomButton loading={loading} htmlType="submit">
                Подключить
              </CustomButton>
            )}

            <CustomButton variant="outlined" loading={loading} htmlType="button" onClick={closeModal}>
              Отмена
            </CustomButton>
          </Flex>
        </Form.Item>
      </Flex>
    </Form>
  );
});
